<template>
  <span class="money-font">
    {{ formattedValue }}
  </span>
</template>

<script>
import { money } from '@/utils/filters';
import { mapGetters } from 'vuex';

export default {
  name: 'Money',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    currency: {
      type: String,
      required: true,
    },
    skipCurrency: {
      type: Boolean,
      default: false,
    },
    skipDecimals: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['currencies']),

    currencySpec() {
      return this.currencies.find(
        (x) => x.code?.toLowerCase() === (this.currency || '').toLowerCase(),
      );
    },

    formattedValue() {
      if (this.value === undefined || this.value === null) {
        return '';
      }

      const formatted = money(
        this.value,
        this.currencySpec?.decimals || 0,
        this.skipDecimals,
      );

      if (!this.currencySpec || this.skipCurrency) {
        return formatted;
      }

      return this.currencySpec.format.replace('%', formatted);
    },
  },
};
</script>

<style lang="scss" scoped>
.money-font {
  font-family: 'DM Mono', monospace;
}
</style>
